import type { ContentUploadWindow } from "../../@types/portalAluno";
import { UPLOAD_WINDOW_OPTIONS } from "./uploadWindow";

export const LISTING_TOPIC_PARAM = "tema";

export const LISTING_PERIOD_PARAM = "periodo";

export const LISTING_TAG_PARAM = "tag";

export const SEARCH_QUERY_PARAM = "q";

export const buildSearchRoute = (query: string) =>
  `/app/busca?${new URLSearchParams({ [SEARCH_QUERY_PARAM]: query.trim() })}`;

export const readSearchQueryParam = (search: string) =>
  new URLSearchParams(search).get(SEARCH_QUERY_PARAM)?.trim() ?? "";

export interface ListingFilters {
  tag?: string | null;
  topicId?: number | null;
  uploadWindow?: ContentUploadWindow | null;
}

export const buildListingRoute = (
  route: string,
  { tag, topicId, uploadWindow }: ListingFilters = {}
) => {
  const params = new URLSearchParams();

  if (topicId) params.set(LISTING_TOPIC_PARAM, String(topicId));
  if (uploadWindow) params.set(LISTING_PERIOD_PARAM, uploadWindow);
  if (tag) params.set(LISTING_TAG_PARAM, tag);

  const query = params.toString();

  return query ? `${route}?${query}` : route;
};

export const readTopicIdParam = (search: string): number | null => {
  const raw = new URLSearchParams(search).get(LISTING_TOPIC_PARAM);

  if (!raw) return null;

  const topicId = Number(raw);

  return Number.isInteger(topicId) && topicId > 0 ? topicId : null;
};

export const readUploadWindowParam = (
  search: string
): ContentUploadWindow | null => {
  const raw = new URLSearchParams(search).get(LISTING_PERIOD_PARAM);

  return (
    UPLOAD_WINDOW_OPTIONS.find((option) => option.value === raw)?.value ?? null
  );
};

export const readTagParam = (search: string) =>
  new URLSearchParams(search).get(LISTING_TAG_PARAM)?.trim() || null;
